import { DeliveryAddress, DeliveryType, TransportCompany } from '@/modules/organizations/types';
import { ProductShared } from '@/modules/products/shared/types';
import { BaseState } from '@/store/base-state';
import { PaginationProps, TableOptions, WareHouse } from '@/types';
import { default_catalog_products_filters } from '@/modules/cart/services';
import {
  CartFilters,
  Cart, CartOrganization, DelLine, CartFileUploadData, CartProject,
} from '../types';

export default class CartState extends BaseState {
  carts_products: Cart.CartItem[] = [];
  items_without_accreditation: Cart.CartItem[] = []

  total_info: Cart.CartTotal = {
    prices: {
      nds_value: 0,
      nds_string_value: '0',
      nds_value_usd: null,
      no_nds_value: 0,
      no_nds_string_value: '0',
      selected_nds_value: 0,
    },
    quantity: 0,
    selected_quantity: 0,
    show_atol_connect_notification: false,
    order_not_possible: false,
    is_only_software_autoshipment: false,
    is_automatic_shipment: false,
    balance_limit: null,
    has_software_registry_items: false,
  };

  edit_license_dialog: Cart.EditLicenseDialog = {
    visible: false,
    loading: false,
    license_key: '',
    item: {} as Cart.CartItem,
  }

  filters: CartFilters = {
    search: '',
  }

  search_key = '';

  isCounterLoading = false;

  cart_loading = false;

  delivery_loading = false;

  current_search = '';

  cart_search_items: ProductShared[] = [];

  warehouses: WareHouse[] = [];

  delivery_addresses: DeliveryAddress[] = [];

  delivery_types: DeliveryType[] = [];

  transport_companies: TransportCompany[] = [];

  organizations: CartOrganization[] = [];

  dl_places: DelLine.DelLinePlace[] = [];

  dl_terminals: DelLine.DelLineTerminal[] = [];

  dl_places_search = '';

  doc_template_link = '';

  file_upload_details: CartFileUploadData = {
    fail_rows: null,
    success_rows: null,
    total_rows: null,
  }

  project_choosen: number | null = null;
  previous_project: number | null = null;

  cart_projects: CartProject[] = [];

  delete_dialog: Cart.DeleteDialog = {
    visible: false,
    type: '',
    selected_products: [],
    is_last_element: false,
  }

  accreditation_dialog: Cart.AccreditationDialog = {
    visible: false,
    loading: false,
    selected_products: [],
    warehouse_id: 0,
    project_id: 0,
  }

  accreditation_message_dialog = false
  accreditation_popup_message: string | null = null;
  added_prod_to_cart = false;

  not_added_product_ids: string[] = [];

  is_cash_registers_auto_addition = true;

  is_disable_btn = false;

  is_open_cart = false;

  realization_contract_dialog = false;
  realization_contract_error_message = '';
  cannot_be_shipped_products: Cart.CartItem[] = [];

  is_not_added_product_modal = false;
  is_not_added_product_message = '';

  catalog_products_loading = false;

  catalog_products: Cart.CatalogProduct[] = [];

  catalog_products_filters: Cart.CatalogProductRequestFilters = default_catalog_products_filters();

  catalog_products_pagination_props: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  catalog_products_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['product_code'],
    sortDesc: [true],
  }
}
